module.exports = __webpack_public_path__ + "img/chrome-logo-monochrome.44ea97fe.png";